import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { maxAreaChange, minAreaChange } from '../../actions';
import { AreaInput as AreaInputComponent } from '../../components/AreaInput';
import { getMaxArea, getMinArea } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';

export function AreaInput() {
  const dispatch: TThunkDispatch = useDispatch();
  const [error, setError] = React.useState(false);
  const minArea = useSelector(getMinArea);
  const maxArea = useSelector(getMaxArea);

  const handleAreaChange = React.useCallback(
    (type: 'minArea' | 'maxArea') => (value: number | void) => {
      const handler = {
        minArea: minAreaChange,
        maxArea: maxAreaChange,
      };

      // здесь использую as, т.к. компонент NumberInput
      // value требует тип number | null
      // onValueChange принимает number | void
      // жду когда добавят NumberInput в ui-kit после заменю данную реализацию
      dispatch(handler[type](value as number | undefined));
      setQueryParameter(type, value);
    },
    [dispatch],
  );

  const handleAreaBlur = React.useCallback(() => {
    if (!!minArea && !!maxArea) {
      setError(minArea > maxArea);
    }
  }, [maxArea, minArea]);

  return (
    <AreaInputComponent
      minArea={minArea}
      maxArea={maxArea}
      error={error}
      onChange={handleAreaChange}
      onBlur={handleAreaBlur}
    />
  );
}
